module.exports = new __parcel__URL__("coins-flat.4191ca5b.svg").toString();